import React from 'react';
import styled from 'styled-components';

interface IProps {
  visible: boolean;
  alignY?: 'top' | 'center' | 'bottom';
  placeholder: React.ReactNode;
  children: React.ReactNode;
}

const Wrapper = styled.div<{ $alignY: IProps['alignY'] }>`
  display: grid;
  align-items: ${({ $alignY }) => ($alignY === 'top' ? 'start' : $alignY === 'bottom' ? 'end' : 'center')};
  width: 100%;
`;
const Layer = styled.div<{ $visible: boolean }>`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  grid-area: 1 / 1;
  width: 100%;
  min-width: 0;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
  user-select: ${({ $visible }) => ($visible ? 'auto' : 'none')};
`;

const Placeholder: React.FC<IProps> = ({ visible, placeholder, children, alignY }) => (
  <Wrapper $alignY={alignY}>
    <Layer $visible={visible} inert={!visible}>
      {children}
    </Layer>
    <Layer $visible={!visible} inert={visible}>
      {placeholder}
    </Layer>
  </Wrapper>
);

export default Placeholder;
